import { Divider, Grid, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";

interface Props {
  title: React.ReactNode;
  body: React.ReactElement;
  id?: string;
  missingCerts?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      fontSize: "1rem",
      fontWeight: "bold",
      lineHeight: "1rem",
      margin: 0,
      paddingTop: "1rem",
      paddingBottom: "1rem",
    },
    button: {
      "float": "right",
      "marginTop": ".5rem",
      "marginBottom": ".5rem",
      "border": "1px solid #ffffff",
      "&:hover": {
        "backgroundColor": theme.palette.secondary.main,
        "border": "1px solid #ced6e3",
        "&:active": {
          backgroundColor: theme.palette.primary.main,
          color: "white",
        },
      },
    },
  }),
);
export default function ShowHideButton({
  title,
  body,
  id,
  missingCerts,
}: Props) {
  const classes = useStyles();

  return missingCerts ? (
    <Grid container style={{ marginBottom: "1rem" }}>
      <Grid item xs={12}>
        <Typography
          variant="h3"
          className={classes.text}
          id={id || "search-pill-title"}
        >
          {title}
        </Typography>
        <Divider style={{ marginBottom: "1rem" }} />
        {body}
      </Grid>
    </Grid>
  ) : (
    <Grid container style={{ marginBottom: "1rem" }}>
      <Grid item xs={10}>
        <Typography
          variant="h3"
          className={classes.text}
          id={id || "search-pill-title"}
        >
          {title}
        </Typography>
      </Grid>
      <Grid item xs={2}></Grid>
      <Grid item xs={12}>
        {body}
      </Grid>
    </Grid>
  );
}
